// tslint:disable-next-line:no-implicit-dependencies
import {Subject, Subscription} from "rxjs";
import {RestDataLoader} from "../../../dashboard/widgets/unilever/RestDataLoader";
import {FilterConfig} from "./AlarmsFilter";

export class EquipmentAlarmsController {

    private filterSubject: Subject<FilterConfig>;

    private alarmCountSubject: Subject<number>;

    private timezoneSubject: Subject<string>;

    constructor() {
        this.filterSubject = new Subject<FilterConfig>();
        this.alarmCountSubject = new Subject<number>();
        this.timezoneSubject = new Subject<string>();
    }

    public applyFilter(config: FilterConfig) {
        this.filterSubject.next(config);
    }

    public listenToFilterChange(listener: (config: FilterConfig) => void): Subscription {
        return this.filterSubject.subscribe(listener);
    }

    public changeAlarmCount(newAlarmCount: number) {
        this.alarmCountSubject.next(newAlarmCount);
    }

    public listenToAlarmCountChange(listener: (alarmCount: number) => void): Subscription {
        return this.alarmCountSubject.subscribe(listener);
    }

    public findTimezone(equipmentGuid: string) {
        RestDataLoader.loadData(
            "equipment/" + equipmentGuid,
            {},
            (result) => {
                this.timezoneSubject.next(result.equipmentInstallation.plant.location.timezoneName as string);
            },
            () => this.timezoneSubject.next(null),
        );
    }

    public listenForTimezone(listener: (tz: string) => void): Subscription {
        return this.timezoneSubject.subscribe(listener);
    }
}
